import { HashRouter } from "react-router-dom"
import AppRouter from './Router/AppRouter'


function App() {
  return (
    <div>
      <HashRouter>
         <AppRouter/>
      </HashRouter>
    
    </div>
  );
}

export default App;
